import React, { useEffect, useState } from "react";
import { Calendar, momentLocalizer, SlotInfo } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Modal, Button, Typography, Box } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Input } from "../../hookFormComponents.tsx/Input";
import { api } from "../../api/api";
import SelectM from "../../hookFormComponents.tsx/Select";
import dayjs from "dayjs";

const localizer = momentLocalizer(moment);

interface Event {
  id: number | null;
  title: string;
  start: Date;
  end: Date;
  employees: any;
}

const initialEvents: Event[] = [
  // {
  //   id: 1,
  //   title: "Available for Booking",
  //   start: new Date("2024-11-03T10:00:00"),
  //   end: new Date("2024-11-03T12:00:00"),
  // },
  // {
  //   id: 2,
  //   title: "Pending Approval",
  //   start: new Date("2024-11-03T12:00:00"),
  //   end: new Date("2024-11-03T14:00:00"),
  // },
];

const Scheduling: React.FC = () => {
  const [tempEvents, setTempEvents] = useState<Event[]>();
  const [events, setEvents] = useState<Event[]>(initialEvents);
  const [open, setOpen] = useState(false);
  const [selectedEvents, setSelectedEvents] = useState<Event[]>([]);
  const [employees, setEmployees] = useState<any>([]);
  const [pressedKey, setPressedKey] = useState("");

  // const [actionType, setActionType] = useState<"approve" | "deny" | null>(null);

  // const handleOpen = (type: "approve" | "deny") => {
  //   setActionType(type);
  //   setOpen(true);
  // };

  useEffect(() => {
    api.get("/users").then((res) =>
      setEmployees(
        res.data.users.map((user: any) => {
          return {
            label: `${user.first_name} ${user.last_name}`,
            value: user.id,
          };
        })
      )
    );

    let isKeyPressed = false;
    const keyInterval = 100;
    let actionInterval: any;

    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.key === "Shift" || event.key === "Control") && !isKeyPressed) {
        isKeyPressed = true;

        actionInterval = setInterval(() => {
          if (event.key === "Shift") {
            setPressedKey("shift");
          }
          if (event.key === "Control") {
            setPressedKey("ctrl");
          }
        }, keyInterval);
      }
    };

    const handleKeyUp = (event: KeyboardEvent) => {
      if (event.key === "Shift" || event.key === "Control") {
        setPressedKey("");
        isKeyPressed = false;
        clearInterval(actionInterval);
        setOpen(true);
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("keyup", handleKeyUp);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, []);

  const handleClose = () => {
    setOpen(false);
    setSelectedEvents([]);
  };

  // const handleConfirm = () => {
  //   // Handle approval or denial logic here
  //   console.log(`Action: ${actionType}, Events:`, selectedEvents);
  //   handleClose();
  // };

  const handleSelectEvent = (event: Event) => {
    if (pressedKey === "ctrl" || pressedKey === "shift") {
      //@ts-ignore
      setSelectedEvents((prev) => {
        if (prev) {
          return [...prev, event];
        } else {
          return event;
        }
      });
    } else {
      setOpen(true);
      setSelectedEvents([event]);
    }
    // const isSelected = selectedEvents.some((se) => se.id === event.id);
    // if (isSelected) {
    //   setSelectedEvents(selectedEvents.filter((se) => se.id !== event.id));
    // } else {
    //   setSelectedEvents([...selectedEvents, event]);
    // }
  };

  const handleSelectSlot = (slotInfo: SlotInfo) => {
    const selectedStartTime = dayjs(slotInfo.start);
    const selectedEndTime = dayjs(slotInfo.end);

    const minHour = 9;
    const maxHour = 17;

    const selectedStartHour = selectedStartTime.hour();
    const selectedEndHour = selectedEndTime.hour();

    if (
      selectedStartHour < minHour ||
      selectedEndHour > maxHour ||
      selectedStartHour > selectedEndHour
    ) {
      alert(`Please select a time between ${minHour}:00 and ${maxHour}:00.`);
      return;
    }

    const slotDuration = moment.duration(60, "minutes");
    const newEvents: any = [];

    let currentStart = moment(slotInfo.start);
    const slotEnd = moment(slotInfo.end);

    while (currentStart.isBefore(slotEnd)) {
      const eventEnd = moment(currentStart).add(slotDuration);
      newEvents.push({
        id: events.length + newEvents.length + 1,
        shift_id: events.length,
        // title: "New Event",
        start: currentStart.toDate(),
        end: eventEnd.toDate(),
      });
      currentStart = eventEnd;
    }

    setTempEvents((prev) => {
      if (prev) {
        return [...prev, ...newEvents];
      } else {
        return newEvents;
      }
    });
    setOpen(true);
  };

  const handleTempEventReset = () => {
    setTempEvents([]);
    setSelectedEvents([]);
    setOpen(false);
    reset();
  };

  const validationSchema = Yup.object({
    // title: Yup.string().required("Required"),
    employees: Yup.array(Yup.string()),
  });

  const {
    formState: { errors },
    control,
    setValue,
    register,
    handleSubmit,
    getValues,
    reset,
  } = useForm<Yup.InferType<typeof validationSchema>>({
    resolver: yupResolver(validationSchema),
  });

  const EventComponent = ({ event }: { event: Event }) => {
    return <span>{event.title}</span>;
  };

  return (
    <div>
      <h1>Event Scheduling</h1>
      <Calendar
        localizer={localizer}
        events={events}
        components={{
          event: EventComponent,
        }}
        startAccessor="start"
        endAccessor="end"
        style={{ height: 500 }}
        selectable
        onSelectEvent={handleSelectEvent}
        view="week"
        onSelectSlot={handleSelectSlot}
        step={60}
        timeslots={1}
      />
      <Modal
        open={open}
        onClose={handleClose}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Box sx={{ width: 300, bgcolor: "background.paper", p: 4 }}>
          <form
            noValidate
            onSubmit={handleSubmit((values) => {
              if (tempEvents) {
                setEvents((prev) => [
                  ...prev,
                  ...tempEvents.map((event) => ({
                    ...event,
                    title: (values.employees as any)
                      .map((value: any) => {
                        let pp = employees.find(
                          (emp: any) => emp.value == value
                        );
                        return pp.label;
                      })
                      .join(", "),
                    employees: (values.employees as any).map((value: any) => {
                      let pp = employees.find((emp: any) => emp.value == value);
                      return pp;
                    }),
                  })),
                ]);
                if (selectedEvents.length > 0) {
                  setEvents(
                    events.map((eve) => {
                      if (eve.id === selectedEvents[0].id) {
                        return {
                          ...eve,
                          title: (values.employees as any)
                            .map((value: any) => {
                              let pp = employees.find(
                                (emp: any) => emp.value == value
                              );
                              return pp.label;
                            })
                            .join(", "),
                          employees: (values.employees as any).map(
                            (value: any) => {
                              let pp = employees.find(
                                (emp: any) => emp.value == value
                              );
                              return pp;
                            }
                          ),
                        };
                      }
                      return eve;
                    })
                  );
                  setSelectedEvents([]);
                }
                handleTempEventReset();
              }
              if (selectedEvents) {
                handleTempEventReset();
              }
            })}
          >
            {/* <Input
              required
              {...register("title")}
              label={"Title"}
              type="text"
              error={errors?.title?.message}
            /> */}
            <Controller
              control={control}
              name="employees"
              render={({ field }) => {
                return (
                  <SelectM
                    label="Employees"
                    required
                    multiple
                    // @ts-ignore
                    value={
                      field.value ? field.value.map((item) => Number(item)) : []
                    }
                    name={field.name}
                    setValue={setValue}
                    errors={errors}
                    options={employees}
                  />
                );
              }}
            />
            <Button
              variant="contained"
              color="error"
              onClick={handleTempEventReset}
            >
              Cancel
            </Button>

            <Button variant="contained" color="success" type="submit">
              Submit
            </Button>
          </form>
        </Box>
      </Modal>
    </div>
  );
};

export default Scheduling;
